import io from 'socket.io-client';
import { getAccessToken, refreshAccessToken } from '../utils/authTokens';
import { clearSession } from '../utils/authSession';

class SocketService {
  private socket: any = null;

  connect() {
    // If already connected, return existing socket
    if (this.socket && this.socket.connected) {
      return this.socket;
    }

    const socketUrl = window.location.hostname === 'localhost' 
      ? 'http://172.235.245.13'  
      : window.location.origin;

    // Get JWT token from localStorage
    const token = getAccessToken();

    if (!token) {
      console.warn('Socket connection skipped - No auth token available');
      return null;
    }

    console.log('Connecting to socket:', socketUrl);
    
    // Connect with authentication token
    this.socket = io(socketUrl, {
      auth: {
        token: token
      },
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket.id);
    });

    this.socket.on('authenticated', (data: any) => {
      console.log('Socket authenticated:', data);
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    this.socket.on('connect_error', async (error: any) => {
      console.error('Socket connection error:', error);
      
      // If authentication failed, redirect to login
      if (error.message && (error.message.includes('Authentication') || error.message.includes('Token'))) {
        const refreshedToken = await refreshAccessToken();
        if (refreshedToken) {
          this.updateAuthToken(refreshedToken);
          return;
        }
        clearSession('Your session expired. Please sign in again.');
      }
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  updateAuthToken(token: string | null) {
    if (!this.socket) {
      return;
    }

    if (!token) {
      this.disconnect();
      return;
    }

    this.socket.auth = { token };
    if (this.socket.connected) {
      this.socket.disconnect();
    }
    this.socket.connect();
  }

  on(event: string, callback: any) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event: string, callback?: any) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  emit(event: string, data?: any) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  // Chat specific methods
  joinChat(chatId: string) {
    this.emit('join_chat', chatId);
  }

  leaveChat(chatId: string) {
    this.emit('leave_chat', chatId);
  }

  sendMessage(chatId: string, content: string) {
    this.emit('send_message', { chatId, content });
  }
}

export const socketService = new SocketService();
